var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"animated-number",class:{ negative: _vm.value < 0 },domProps:{"textContent":_vm._s(_vm.formattedValue)}})
}
var staticRenderFns = []

export { render, staticRenderFns }